/*
 * Which version of the workflow a run executed, as its tag reads: "v3" for a published version, "Draft" for the draft
 * (Run now and tests run the draft). It is what ties a streak of failures to the publish that caused them. Null when the
 * run carries no version — schedule and trigger thread runs share the run lists and have none.
 */
const formatWorkflowRunVersionLabel = (run) => {
  const version = String(run?.workflowVersion || '').trim();

  if (!version) {
    return null;
  }

  return version === 'draft' ? 'Draft' : `v${version}`;
};

export default formatWorkflowRunVersionLabel;
